// Module
var code = "<div class=\"sessions\"><header class=\"login-register-header\"><img ng-src=\"{{completeRegistrationLogo}}\" alt=\"{{brandNameShort}}\" data-no-retina></header><div class=\"sessions institution-register\"><confirm-profile-info-form></confirm-profile-info-form></div><login-register-footer></login-register-footer></div>";
// Exports
export default code;